import React, { useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import { getAllReferrals, markReferralConverted } from "../../Services/phase2Service";

const statusColor = {
  pending: "bg-gray-100 text-gray-500",
  joined: "bg-blue-100 text-blue-700",
  converted: "bg-green-100 text-green-700",
};

const ReferralsAdmin = () => {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      setRows((await getAllReferrals(status ? { status } : {})) || []);
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const convert = async (referred_advisor_id) => {
    if (!referred_advisor_id) return toast.error("No referred advisor id");
    try {
      await markReferralConverted(referred_advisor_id);
      toast.success("Marked converted");
      load();
    } catch {
      toast.error("Failed");
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold text-gray-800">Referrals</h1>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="border border-gray-200 rounded-lg px-3 py-2 text-sm"
        >
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="joined">Joined</option>
          <option value="converted">Converted</option>
        </select>
      </div>

      <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-500 text-left">
            <tr>
              <th className="px-4 py-3">Referrer</th>
              <th className="px-4 py-3">Referred</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Points</th>
              <th className="px-4 py-3">Cashback</th>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="px-4 py-6 text-center text-gray-400">
                  Loading…
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-4 py-6 text-center text-gray-400">
                  No referrals.
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.id} className="border-t border-gray-50">
                  <td className="px-4 py-3">{String(r.referrer_advisor_id).slice(0, 8)}</td>
                  <td className="px-4 py-3">
                    {r.referred_name || String(r.referred_advisor_id || "-").slice(0, 8)}
                  </td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-xs ${statusColor[r.status] || ""}`}>
                      {r.status}
                    </span>
                  </td>
                  <td className="px-4 py-3">{r.reward_points}</td>
                  <td className="px-4 py-3">₹{Number(r.reward_amount).toLocaleString("en-IN")}</td>
                  <td className="px-4 py-3">{moment(r.created_at).format("DD MMM YYYY")}</td>
                  <td className="px-4 py-3">
                    {r.status === "joined" && r.referred_advisor_id && (
                      <button
                        onClick={() => convert(r.referred_advisor_id)}
                        className="text-xs bg-green-50 text-green-700 border border-green-200 rounded-lg px-3 py-1"
                      >
                        Mark converted
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReferralsAdmin;
